import React from "react";

import Panel from "../../shared/panel/panel";
import PrepaidPanelComponent from "@/components/subscriptions/prepaidPanel";
import { Trans } from "react-i18next";

const PrepaidPanel = () => {
  return (
    <Panel mode="light" title="subscriptions.prepaid.title" marginBottom>
      <div className="flex flex-col gap-8 px-8 pb-0 pt-6">
        <p>
          <Trans i18nKey="subscriptions.prepaid.description" />
        </p>
        <PrepaidPanelComponent />
      </div>
    </Panel>
  );
};

export default PrepaidPanel;
